import { AuthActionBuilder, AuthService, Browser } from 'ionic-appauth'
import { Requestor, RevokeTokenRequest, StorageBackend } from '@openid/appauth'
import { __awaiter } from 'tslib'
import { RevokeTokenRequestJson } from '@openid/appauth/src/revoke_token_request'
import { inject, Injectable } from '@angular/core'

const TOKEN_RESPONSE_KEY = 'token_response'

@Injectable({
  providedIn: 'root'
})
export class CoreAuthService extends AuthService {
  constructor(
    browser: Browser = inject(Browser, { optional: true }),
    storage: StorageBackend = inject(StorageBackend, { optional: true }),
    requestor: Requestor = inject(Requestor, { optional: true })
  ) {
    super(browser, storage, requestor)
  }

  override requestTokenRevoke() {
    return __awaiter(this, void 0, void 0, function* () {
      const revokeAccessJson: RevokeTokenRequestJson = {
        token: this._tokenSubject.value.accessToken,

        token_type_hint: 'access_token',

        client_id: this.authConfig.client_id
      }
      yield this.tokenHandler.performRevokeTokenRequest(
        yield this.configuration,
        new RevokeTokenRequest(revokeAccessJson)
      )
      yield this.storage.removeItem(TOKEN_RESPONSE_KEY)
      this.notifyActionListers(AuthActionBuilder.RevokeTokensSuccess())
    })
  }

  override signOut(state?: string, revokeTokens?: boolean) {
    return __awaiter(this, void 0, void 0, function* () {
      if (revokeTokens) {
        yield this.revokeTokens()
      }
      if (yield this.storage.getItem(TOKEN_RESPONSE_KEY)) {
        yield this.storage.removeItem(TOKEN_RESPONSE_KEY)
      }
      if ((yield this.configuration).endSessionEndpoint) {
        yield this.performEndSessionRequest(state).catch((response) => {
          this.notifyActionListers(AuthActionBuilder.SignOutFailed(response))
        })
      }
    })
  }
}
